import { AbstractControl, ValidationErrors } from '@angular/forms';

export const number = (control: AbstractControl): ValidationErrors | null => {
  const key = 'number';

  const value = control.value;

  if (!value) return null;

  const result = /^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(value);

  if (!result)
    return {
      [key]: true,
    };

  return null;
};
